import { useEffect } from 'react';

import { setUserTraits } from '@/config/observability';
import { useEntitlementsUsage } from '@/hooks/account/useBilling';
import { useUserProfile } from '@/hooks/account/useUser';

/**
 * Keeps the PostHog person's traits (role, plan, onboarded, signup date) in
 * step with the app, so every insight can be split by them. Both queries are
 * already warm on every AppLayout route (OnboardingGate, the usage meters),
 * so this adds no requests. Renders nothing.
 */
export function AnalyticsIdentity() {
  const { data: profile } = useUserProfile();
  const { data: usage } = useEntitlementsUsage();

  const role = profile?.learning_profile?.role ?? null;
  const onboarded = profile?.onboarded;
  const signupDate = profile?.created_at;
  const tier = usage?.tier;
  const accessOverride = usage?.access_override;

  useEffect(() => {
    if (onboarded === undefined) return;
    setUserTraits({ role, onboarded, signup_date: signupDate });
  }, [role, onboarded, signupDate]);

  useEffect(() => {
    if (!tier) return;
    setUserTraits({ tier, access_override: accessOverride });
  }, [tier, accessOverride]);

  return null;
}
